// 处理手机和pc切换导致无法进入相应适配的问题
export default {
	mounted() {
		// pc页面
		const pcrmisson = ['webIndex', 'activitiesList', 'activitiesDetail']
		// 手机页面
		const phonesson = ['phoneIndex', 'phoneActivitiesList', 'phoneActivitiesDetail']
		const routePath = this.$route.name
		window.onresize = () => (() => {
			const screenWidth = window.screen.width;
			// 手机
			if (screenWidth < 760 && pcrmisson.includes(routePath)) {
				const index = pcrmisson.indexOf(routePath)
				if (index == 2) {
					this.$router.replace({
						name: phonesson[1]
					})
				} else {
					this.$router.replace({
						name: phonesson[index]
					})
				}
			}
			// pc
			if (screenWidth > 760 && phonesson.includes(routePath)) {
				const index = phonesson.indexOf(routePath)
				if (index == 2) {
					this.$router.replace({
						name: pcrmisson[1]
					})
				} else {
					this.$router.replace({
						name: pcrmisson[index]
					})
				}
			}
		})()
	},
}